export const calcNearestStep = (value: number, step = 0.05) => {
  step || (step = 1.0);
  const inv = 1.0 / step;
  return Math.round(value * inv) / inv;
};
